import { NavLink, useLocation } from 'react-router-dom';
import { Home, LayoutGrid, Package, ShoppingCart } from 'lucide-react';
import { useCartStore } from '@/stores/cartStore';
import { cn } from '@/lib/utils';

type TabItem = {
  to: string;
  label: string;
  icon: typeof Home;
  end?: boolean;
  match?: string;
};

const tabs: TabItem[] = [
  { to: '/', label: 'Inicio', icon: Home, end: true },
  { to: '/catalogo', label: 'Catálogo', icon: LayoutGrid, match: 'catalog' },
  { to: '/kits', label: 'Kits', icon: Package, match: 'kits' },
];

function isTabActive(pathname: string, match: string | undefined, end?: boolean) {
  if (end) return pathname === '/';
  if (match === 'catalog') {
    return pathname === '/catalogo' || pathname.startsWith('/producto/');
  }
  if (match === 'kits') {
    return pathname === '/kits' || pathname.startsWith('/kits/');
  }
  return false;
}

export function MobileTabBar() {
  const { pathname } = useLocation();
  const itemCount = useCartStore((s) => s.itemCount());
  const toggleCart = useCartStore((s) => s.toggleCart);
  const onCheckout = pathname === '/checkout';

  return (
    <nav
      className="mobile-tab-bar lg:hidden"
      aria-label="Navegación principal"
    >
      {tabs.map(({ to, label, icon: Icon, end, match }) => {
        const active = isTabActive(pathname, match, end);
        return (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={cn('mobile-tab-item', active && 'mobile-tab-item-active')}
            aria-current={active ? 'page' : undefined}
          >
            <Icon className="h-5 w-5" strokeWidth={active ? 2.25 : 1.75} />
            <span>{label}</span>
          </NavLink>
        );
      })}

      <button
        type="button"
        onClick={() => toggleCart(true)}
        className={cn('mobile-tab-item', onCheckout && 'mobile-tab-item-active')}
        aria-label="Carrito"
      >
        <span className="relative">
          <ShoppingCart className="h-5 w-5" strokeWidth={onCheckout ? 2.25 : 1.75} />
          {itemCount > 0 && (
            <span className="absolute -right-2 -top-1.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-brand-600 px-0.5 font-mono text-[9px] font-bold text-white">
              {itemCount > 99 ? '99+' : itemCount}
            </span>
          )}
        </span>
        <span>Carrito</span>
      </button>
    </nav>
  );
}
